import { render, staticRenderFns } from "./CreditCard.vue?vue&type=template&id=12a3ab68&"
import script from "./CreditCard.vue?vue&type=script&lang=js&"
export * from "./CreditCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports